var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIconNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3749 10.9976H5.06648M4.91602 11.7062L4.03899 14.3741C3.55865 15.8353 3.31848 16.5659 3.49083 17.0157C3.64051 17.4065 3.96198 17.7027 4.35865 17.8155C4.81544 17.9453 5.50536 17.6291 6.88519 16.9968L15.7312 12.943C17.0781 12.3258 17.7515 12.0173 17.9596 11.5885C18.1404 11.2161 18.1404 10.779 17.9596 10.4066C17.7515 9.97797 17.0781 9.66935 15.7312 9.05215L6.86994 4.99142C5.49425 4.36101 4.80642 4.0458 4.35009 4.17511C3.95379 4.2874 3.63235 4.58282 3.48216 4.9728C3.30921 5.42186 3.54681 6.15087 4.02203 7.60887L4.91772 10.357C4.99933 10.6074 5.04015 10.7326 5.05625 10.8606C5.07055 10.9743 5.0704 11.0893 5.05583 11.2029C5.03939 11.3309 4.99827 11.456 4.91602 11.7062Z",
    stroke: "#E9BE50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIconNew);
export default __webpack_public_path__ + "static/media/sendIconNew.0dd7f5f61c4e5ba74d85b6b589ea425a.svg";
export { ForwardRef as ReactComponent };